import React, { useEffect, useState } from 'react';
import './modal.css';
import { Link } from "gatsby";
import SwipeGallery from './swipeGallery';

const Modal = (props) => {
  const [imageIndex, setImageIndex] = useState(props.startIndex);
  const [currentImage, setCurrentImage] = useState();
  const [currentCategory, setCurrentCategory] = useState();
  const [currentTitle, setCurrentTitle] = useState();
  const [currentComment, setCurrentComment] = useState();

  const imageItems = props.imageItems;
  const lastImageIndex = props.lastImageIndex;

  useEffect(() => {
    window.addEventListener('keydown', e => {
      if(e.key === 'ArrowLeft') {
        return advance(-1);
      }
      if (e.key === 'ArrowRight') {
        return advance(1);
      }
    });
  }, []);

  useEffect(() => {
    setCurrentImage(imageItems[imageIndex].image);
    setCurrentCategory(imageItems[imageIndex].category);
    setCurrentTitle(imageItems[imageIndex].title);
    setCurrentComment(imageItems[imageIndex].comment);
  }, [imageIndex]);

  const advance = (step) => {
    setImageIndex(current => {
      const next = current + step;
      if (next > lastImageIndex) {
        return 0;
      } else if (next < 0) {
        return lastImageIndex;
      }
      return next;
    });
  };

  const onImageChange = (newIndex) => {
    setImageIndex(newIndex);
  }

  return (
    <div className="modal_container">
      <div className="white_box">
        <div className="left_box">
          <button 
            className="left_modal_button"
            onClick={() => advance(-1)}
          >
          <i className="fas fa-chevron-left fontFour"></i>
          </button>
        </div>
        <div className="close_box">
          <button 
            className="close_modal_button"
            onClick={props.onClose}
          >&times;</button>
        </div>
        <div className="title_box">
          <span>
            <button className="link_category_button">
              <Link to={"/projects/#" + currentCategory}>
                <i className="far fa-folder"></i>{currentCategory} 
              </Link>
            </button>
            <h2 className="modal_font"> / </h2>
            <h2 className="modal_title modal_font">
              {currentTitle}
            </h2>
          </span>
        </div>
        <UseViewport 
          currentImage= {currentImage}
          imageItems = {imageItems}
          imageIndex = {imageIndex}
          lastImageIndex = {lastImageIndex}
          onImageChange = {onImageChange}
        />
        <div className="comment_box">
          <h3 className="modal_comment">
            {currentComment}
          </h3>
        </div>
        <div className="right_box">
          <button 
            className="right_modal_button"
            onClick={() => advance(1)}
          >
            <i className="fas fa-chevron-right fontFour"></i>
          </button>
        </div>
        <div className="empty_box"></div>
      </div>
    </div>
  )
};

const UseViewport = (props) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const breakpoint = 992;

  useEffect(() => {
    const handleWindowResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);

  return width < breakpoint 
    ? <SwipeGallery 
        imageItems = {props.imageItems}
        imageIndex = {props.imageIndex}
        lastImageIndex = {props.lastImageIndex}
        onImageChange = {props.onImageChange}
        screenWidth = {width}
        screenHeight = {height}
      /> 
    : <NonSwipeGallery 
        currentImage = {props.currentImage}
        imageIndex = {props.imageIndex}
      />
};

const NonSwipeGallery = (props) => {
  return (

    <img 
      src={props.currentImage}
      className= "modal_image"
      alt="images in modal"
    ></img>

  )
};

export default Modal;